import day from "./day.js";
import night from "./night.js";

const themes = { night, day };

export default themes;
